import { render, staticRenderFns } from "./AsocNotaCuenta.vue?vue&type=template&id=f9994102"
import script from "./AsocNotaCuenta.vue?vue&type=script&lang=js"
export * from "./AsocNotaCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports